import { createFileRoute, Outlet, notFound } from "@tanstack/react-router";
import { getState } from "@/data/states";

export const Route = createFileRoute("/construction-loans/$state")({
  loader: ({ params }) => {
    const state = getState(params.state);
    if (!state) throw notFound();
    return { state };
  },
  component: () => <Outlet />,
});
